// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store.js';
import Vuex from 'vuex';
import ElementUI from 'element-ui'
ElementUI.Dialog.props.lockScroll.default = false;
import './public/element-variables.scss'
import '@/mock'
// import './utils/affectButton.js'
import VueApexCharts from 'vue-apexcharts'
import './common/font/font.css'
import './common/font/fontBold.css'
import './assets/font/iconfont.css'; //阿里云字体图标
import 'bootstrap/dist/css/bootstrap.min.css';
import VueClipboard from 'vue-clipboard2';
// import echarts from 'echarts'
// import preventReClick from './common/plugins';
import preventReClick from './utils/repeatClick';
Vue.config.productionTip = false;
import watermark from '@/assets/watermark.js';
Vue.prototype.$watermark = watermark; 
import moment from 'moment'; // 时间处理
Vue.prototype.$moment = moment;


Vue.prototype.$store = store;
// Vue.prototype.$echarts = echarts
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
Vue.use(VueClipboard);
Vue.use(preventReClick);
Vue.prototype.$globalVar = 'Hello World';

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js